module.exports = __webpack_public_path__ + "img/playing.8b6db65d.png";